import React from 'react';
import CSSModules from 'react-css-modules';
import style from './h1.scss';

const H1 = props => (
  <h1 styleName={`root ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}>
    {props.children}
  </h1>
);

export default CSSModules(H1, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/h1.js